/* eslint-disable @typescript-eslint/no-explicit-any */
export const flattenObjectStrings = (obj: Record<string, any>): string[] => {
  const result: string[] = [];

  function traverse(obj: any) {
    if (typeof obj === 'string') {
      result.push(obj);
    } else if (Array.isArray(obj)) {
      obj.forEach((item) => {
        if (typeof item === 'string') {
          result.push(item);
        } else if (typeof item === 'object' && item !== null) {
          traverse(item);
        }
      });
    } else if (typeof obj === 'object' && obj !== null) {
      for (const key in obj) {
        // eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty(key)) {
          traverse(obj[key]);
        }
      }
    }
  }

  traverse(obj);
  return result;
};
